import { render, staticRenderFns } from "./activeRest.vue?vue&type=template&id=3fe10c1a"
import script from "./activeRest.vue?vue&type=script&lang=js"
export * from "./activeRest.vue?vue&type=script&lang=js"
import style0 from "./activeRest.vue?vue&type=style&index=0&id=3fe10c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports